import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import YellowGreenButton from './YellowGreenButton';
import i18n from '../utils/i18n';

import './styles/QuickBookingFooter.scss';

class QuickBookingFooter extends React.Component {
  getAttendiesInputs() {
    let inputs = [];
    inputs = this.props.radioOptions.map(option => (
      <label htmlFor="x" key={ option.value }>
        <input
          type="radio"
          value={ option.value }
          name="booking_attendies"
          checked={ this.props.chosenRadioOptionValue === option.value }
          onChange={ this.props.onRadioOptionChange }
        />
        {option.label}
      </label>
    ));
    return inputs;
  }

  render() {
    const anyRadioOptionAvailable =
      this.props.radioOptions && this.props.radioOptions.length > 0;

    return (
      <div className="booking">
        <div>
          <hr />
          {anyRadioOptionAvailable ? (
            <div>
              <div className="radio-buttons-label">
                {this.props.radioButtonsLabel}
              </div>
              <div className="radio-buttons-choice">
                {this.getAttendiesInputs()}
              </div>
            </div>
          ) : (
            <div className="no-radio-buttons-break" />
          )}
          <div className="next-button-wrapper">
            <YellowGreenButton
              onClick={ this.props.bookingNextAction }
              text={ i18n.t('quickBookingFooter.CONFIRM_BOOKING') }
              style={ {
                width: '200px',
                marginTop: '20px'
              } }
            />
          </div>
        </div>
        <div
          className="cancel-booking-wrapper"
          onClick={ this.props.bookingCancelAction }
        >
          {i18n.t('quickBookingFooter.CANCEL')}
          <FontAwesome className="arrow-right" name="arrow-right" />
        </div>
      </div>
    );
  }
}

QuickBookingFooter.propTypes = {
  bookingCancelAction: PropTypes.func.isRequired,
  bookingNextAction: PropTypes.func.isRequired,
  radioOptions: PropTypes.arrayOf(PropTypes.shape({})),
  chosenRadioOptionValue: PropTypes.number,
  onRadioOptionChange: PropTypes.func,
  radioButtonsLabel: PropTypes.string
};

QuickBookingFooter.defaultProps = {
  radioOptions: [],
  chosenRadioOptionValue: null,
  onRadioOptionChange: () => {},
  radioButtonsLabel: ''
};

export default QuickBookingFooter;



// WEBPACK FOOTER //
// ./src/components/QuickBookingFooter.js